/**
 * Copyright (c) ActiveWidgets SARL. All Rights Reserved.
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import converter from '@activewidgets/frameworks/svelte';
import * as Svelte from 'svelte/internal';

export const {component: SvelteComponent} = converter(Svelte);

export const Content = SvelteComponent(({slots}) => {
    return ({src, params}) => src ? src(params) : slots.default && slots.default();
});